module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M17.36 11.58c.25-.822.546-1.678.546-2.58 0-4.97-3.966-9-8.938-9S0 4.03 0 9s4.044 9 9.016 9c.902 0 1.516-.174 2.336-.42l.18.42v4h4v4h4v4h4.5l2 2h5.5v-6L17.36 11.58zM7.032 10c-1.658 0-3-1.342-3-3s1.342-3 3-3 3 1.342 3 3-1.342 3-3 3z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/key-1.js
// module id = 1200
// module chunks = 14